import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { atvlogin } from 'src/app/shared/constants';
import { environment } from 'src/environment';
import { SettingsService } from '.';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ActivateAppletvService {

  constructor(private http: HttpClient, private storageService: StorageService, 
    private settingsService: SettingsService) { }

  validateOTP(code: string): Observable<any> {
    const region: string = this.storageService.getLocalStore('region');
    const locale: string = this.storageService.getLocalStore('locale');
    const dId: string = this.storageService.getLocalStore('d_id');
    let params = new HttpParams()
      .set('region', region)
      .set('locale', locale)
      .set('u_id', dId)
      .set('mcode', code);
    let postData = this.settingsService.handleDataMartAnalyticsParamsData();
    const editUrl = environment.apiEndpoint + environment.version + atvlogin;
    return this.http.post<any>(editUrl, postData, { params }).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response;
        }
      })
    );
  }
}
